import type {
  CompetitorAnalysisRequest,
  CompetitorMatchedProductsRequest,
  CompetitorProductsRequest,
} from "./types";

export const COMPETITOR_QUERY_KEYS = {
  default: () => ["competitor"] as const,
  analysis: (params?: CompetitorAnalysisRequest) =>
    [...COMPETITOR_QUERY_KEYS.default(), "analysis", params] as const,
  products: (params?: CompetitorProductsRequest) =>
    [...COMPETITOR_QUERY_KEYS.default(), "products", params] as const,
  brands: () => [...COMPETITOR_QUERY_KEYS.default(), "brands"] as const,
  matchedProducts: (params: CompetitorMatchedProductsRequest) =>
    [...COMPETITOR_QUERY_KEYS.default(), "matchedProducts", params] as const,
};
